export default "__VITE_ASSET__9AAAkQlV__"